export function IssuesSearchForm({
  startDate,
  endDate,
  orderNumber,
  sotNumber,
  recipientName,
  onStartDateChange,
  onEndDateChange,
  onOrderNumberChange,
  onSotNumberChange,
  onRecipientNameChange,
  onSearch,
}) {
  return (
    <article className="card" style={{ marginBottom: '15px' }}>
      <header>
        <i className="fa fa-search"></i>
        <label>Advanced Search</label>
      </header>
      <div className="body">
        <div className="group">
          <div className="span3">
            <div className="field">
              <label>Start Date</label>
              <input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} />
            </div>
          </div>
          <div className="span3">
            <div className="field">
              <label>End Date</label>
              <input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} min="2020-06-01" />
              <p style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Minimum: June 1, 2020</p>
            </div>
          </div>
          <div className="span3">
            <div className="field">
              <label>Order Number</label>
              <input type="text" value={orderNumber} onChange={(e) => onOrderNumberChange(e.target.value)} placeholder="Enter order number" />
            </div>
          </div>
          <div className="span3">
            <div className="field">
              <label>Item / SOT Number</label>
              <input type="text" value={sotNumber} onChange={(e) => onSotNumberChange(e.target.value)} placeholder="Enter item number" />
            </div>
          </div>
        </div>
        <div className="group">
          <div className="span6">
            <div className="field">
              <label>Comments (search)</label>
              <input type="text" value={recipientName} onChange={(e) => onRecipientNameChange(e.target.value)} placeholder="Search in comments" />
            </div>
          </div>
          <div className="span6">
            <div className="field" style={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
              <button className="btn-blue right" onClick={onSearch}>
                <i className="fa fa-search"></i> Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
